import BookkeepingIcon from 'assets/images/accounting/icons/bookkeeping.svg?react';
import ExpenseIcon from 'assets/images/accounting/icons/expense.svg?react';
import ReportingIcon from 'assets/images/accounting/icons/reporting.svg?react';
import SaveTimeIcon from 'assets/images/accounting/icons/save-time.svg?react';
import ScaleIcon from 'assets/images/accounting/icons/scale.svg?react';
import TransparencyIcon from 'assets/images/accounting/icons/transparency.svg?react';
import TrustIcon from 'assets/images/accounting/icons/trust.svg?react';

export const FEATURE_CARDS = [
  {
    testId: 'marketing-feature-card-1',
    Icon: BookkeepingIcon,
    titleKey: 'pageHostfullyAccounting.marketing.features.card1.title',
    descriptionKey:
      'pageHostfullyAccounting.marketing.features.card1.description',
    bulletKeys: [
      'pageHostfullyAccounting.marketing.features.card1.bullet1',
      'pageHostfullyAccounting.marketing.features.card1.bullet2',
      'pageHostfullyAccounting.marketing.features.card1.bullet3',
    ],
  },
  {
    testId: 'marketing-feature-card-2',
    Icon: TrustIcon,
    titleKey: 'pageHostfullyAccounting.marketing.features.card2.title',
    descriptionKey:
      'pageHostfullyAccounting.marketing.features.card2.description',
    bulletKeys: [
      'pageHostfullyAccounting.marketing.features.card2.bullet1',
      'pageHostfullyAccounting.marketing.features.card2.bullet2',
      'pageHostfullyAccounting.marketing.features.card2.bullet3',
    ],
  },
  {
    testId: 'marketing-feature-card-3',
    Icon: ExpenseIcon,
    titleKey: 'pageHostfullyAccounting.marketing.features.card3.title',
    descriptionKey:
      'pageHostfullyAccounting.marketing.features.card3.description',
    bulletKeys: [
      'pageHostfullyAccounting.marketing.features.card3.bullet1',
      'pageHostfullyAccounting.marketing.features.card3.bullet2',
      'pageHostfullyAccounting.marketing.features.card3.bullet3',
    ],
  },
  {
    testId: 'marketing-feature-card-4',
    Icon: ReportingIcon,
    titleKey: 'pageHostfullyAccounting.marketing.features.card4.title',
    descriptionKey:
      'pageHostfullyAccounting.marketing.features.card4.description',
    bulletKeys: [
      'pageHostfullyAccounting.marketing.features.card4.bullet1',
      'pageHostfullyAccounting.marketing.features.card4.bullet2',
      'pageHostfullyAccounting.marketing.features.card4.bullet3',
    ],
  },
] as const;

export const BENEFIT_CARDS = [
  {
    testId: 'marketing-benefit-card-1',
    Icon: SaveTimeIcon,
    titleKey: 'pageHostfullyAccounting.marketing.benefits.card1.title',
    descriptionKey:
      'pageHostfullyAccounting.marketing.benefits.card1.description',
  },
  {
    testId: 'marketing-benefit-card-2',
    Icon: TransparencyIcon,
    titleKey: 'pageHostfullyAccounting.marketing.benefits.card2.title',
    descriptionKey:
      'pageHostfullyAccounting.marketing.benefits.card2.description',
  },
  {
    testId: 'marketing-benefit-card-3',
    Icon: ScaleIcon,
    titleKey: 'pageHostfullyAccounting.marketing.benefits.card3.title',
    descriptionKey:
      'pageHostfullyAccounting.marketing.benefits.card3.description',
  },
] as const;

export type MarketingCardContent =
  | (typeof FEATURE_CARDS)[number]
  | ((typeof BENEFIT_CARDS)[number] & { bulletKeys?: undefined });

export const HF_ACCOUNTING_CONTACT_URL =
  'https://www.hostfully.com/customer-upgrade/?q_showExperience=experience-1784640048740&main_product=accounting';
